export class mtasModel {
setValue(res){
if(res){
}
}
}